/**
 * function to check currency in brazilian market
 * should always be BRL for /pt
 */
$(document).ready(function(){
    if(Shopify.locale === 'pt-BR'){
        const currencyCookie = getCookie('cart_currency');
        if(currencyCookie !== 'BRL'){
            // get currency form and submit
            const currencyForm = $('#currency_form');
            const currencyInput = currencyForm?.find('input[name="currency"]');
            currencyInput.val('BRL');
            currencyForm.submit();
        }
    }
    function waitForBeamerConfig() {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (window.beamer_config) {
                        clearInterval(interval);
                        resolve(window.beamer_config);
                    }
                }, 100);
            });
        }
        waitForBeamerConfig().then((config) => {
            console.log("Beamer config loaded:", config);
            config.language = Shopify.locale === 'pt-BR' ? 'pt' : Shopify.locale;
            const beamerIcon = document.querySelector('#callBeamer');
            if (beamerIcon) {
                beamerIcon.setAttribute('tabindex', '0');
                beamerIcon.setAttribute('aria-label', 'Notifications');
                beamerIcon.setAttribute('role', 'button');
            }
        });
        function waitForIntercomSettings() {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (window.intercomSettings) {
                        clearInterval(interval);
                        resolve(window.intercomSettings);
                    }
                }, 100);
            });
        }
        waitForIntercomSettings().then((settings) => {
            console.log("Intercom settings loaded:", settings);
            settings.language_override = Shopify.locale === 'pt-BR' ? 'pt' : Shopify.locale;
            if(window.innerWidth < 768){
                setTimeout(() => {
                    const intercomLauncher = document.querySelector('.intercom-lightweight-app-launcher');
                    if (intercomLauncher) {
                        intercomLauncher.style.setProperty("bottom", "120px", "important");
                    }
                }, 1500);
            }
        });
});
(function () {
    var params = new URLSearchParams(window.location.search);
    var isCheckoutLinkFlow = localStorage.getItem('isCheckoutLinkFlow');
    if(!isCheckoutLinkFlow)localStorage.setItem('currentRoute',window.location.href.split(/[?#]/)[0]);
    if(params.has('error')){
        let switch_company_error=localStorage.getItem('switchCompanyError')
        localStorage.setItem('switchCompanySuccess',false)
        if(switch_company_error=='true'){
            $('#retry_href').attr('href','/pages/company-list')
            $('#switch-company-error').css('display','flex')
            localStorage.removeItem('currentCompany')
        }else{
            $('#alert-pop-up').fadeIn();
            $('#alert-pop-up p').text(params.get('error'));
        }
    }else{
        localStorage.setItem('switchCompanyError',false)
     }
  
    $(document).on('click','#nav-icon4',function(){
		$(this).toggleClass('open');
        $('.l-header-menu-block').toggleClass('open').css('height', window.innerHeight);
        if(!$(this).hasClass('open')){
            $('.l-header-menu-block').removeClass('open');
        }
	});
    $('body').click(function(e) {
        if (!$(e.target).closest('.l-header-menu').length){
            $(".l-header-menu-block").removeClass('open');
            $('body').removeClass('overlay-color');
        }
        if (!$(e.target).closest('#nav-icon4').length){
            if (!$(e.target).closest('.l-header-menu').length){
            $(".hideShow").removeClass('open');
            }
        }
        if (e.target?.getAttribute('href') === "#chatwithus" || e.target?.parentElement?.getAttribute('href') === "#chatwithus") {
            Intercom('show');
        }
    })

    $(document).on('click','#nav-icon4',function(){
        if($(this).parent('.l-header-menu-block').hasClass('open')){
            $('body').removeClass('overlay-color');
        }else{
            $('body').addClass('overlay-color');
        }
    })

    $(document).on('click','.inner-menu-burger-menu',function(){
        $('#nav-icon4.hideShow:not(.inner-menu-burger-menu)').removeClass('open');
        $('body').removeClass('overlay-color');
    }) 

    $(document).on('click','.l-header-language-wrapper .l-dropdown-selected',function(){
        $('.l-header-language-wrapper ul li').slideToggle();
        $('.l-header-language-wrapper .l-dropdown-selected ').toggleClass('open');
        
        // Update aria-expanded attribute
        const isOpen = $('.l-header-language-wrapper .l-dropdown-selected').hasClass('open');
        $('.l-header-language-wrapper .l-dropdown-selected').attr('aria-expanded', isOpen);
    });

    $(document).on('keypress','.l-header-language-wrapper .l-dropdown-selected',function(e){
        if(e.keyCode == 13){ 
            $('.l-header-language-wrapper ul li').slideToggle();
            $('.l-header-language-wrapper .l-dropdown-selected ').toggleClass('open');
            
            // Update aria-expanded attribute
            const isOpen = $('.l-header-language-wrapper .l-dropdown-selected').hasClass('open');
            $('.l-header-language-wrapper .l-dropdown-selected').attr('aria-expanded', isOpen);
        }
    });

    $(document).on('click','.click-li',function(){
        if($(window).width() < 1025){
            $('.show-hide-li').slideToggle();
        }
    });

    $(window).resize(function(){
        if($(this).width() > 1024){
            $('.show-hide-li').show();
        }
    })

    $('#nav-icon4').on('click', function(event) {
        $('.l-header-menu-block #mobileNavigation .mtf-header-menu-link').removeAttr('tabindex');
        $('.login-text').removeAttr('tabindex');
        $('.login-text a').removeAttr('tabindex');
    });

    $('.l-header-menu-block #nav-icon4').on('click', function(event) {
        $('.l-header-menu-block #mobileNavigation .mtf-header-menu-link').attr('tabindex', '-1');
        $('.login-text').attr('tabindex', '-1');
        $('.login-text a').attr('tabindex', '-1');
    });

    // Function to close language dropdown
    function closeLanguageDropdown() {
        $(".l-header-language-wrapper .select-list li").slideUp();
        $('.l-header-language-wrapper .l-dropdown-selected ').removeClass('open');
        $('.l-header-language-wrapper .l-dropdown-selected').attr('aria-expanded', 'false');
    }

    // Function to close profile menu
    function closeProfileMenu() {
        $('.l-header-profile-user').removeClass('open');
        updateProfileMenuTabIndex();
    }

    // Function to update profile menu tabindex based on open/closed state
    function updateProfileMenuTabIndex() {
        const isOpen = $('.l-header-profile-user').hasClass('open');
        const profileMenuItems = $('.l-header-profile-menu a');
        
        if (isOpen) {
            // When menu is open, make items tabbable
            profileMenuItems.removeAttr('tabindex');
            $('.l-header-profile-user').attr('aria-expanded', 'true');
        } else {
            // When menu is closed, make items not tabbable
            profileMenuItems.attr('tabindex', '-1');
            $('.l-header-profile-user').attr('aria-expanded', 'false');
        }
    }

    $(document).on('click', function (e) {
        if ($(e.target).closest(".l-header-language-wrapper").length === 0) {
            closeLanguageDropdown();
        }
        if ($(e.target).closest(".l-header-profile-block").length === 0) {
            closeProfileMenu();
        }
    });

    // Keyboard navigation support for language dropdown
    $(document).on('keydown', '.l-header-language-wrapper', function(e) {
        // Close dropdown on Escape key
        if (e.key === 'Escape' || e.keyCode === 27) {
            closeLanguageDropdown();
            $('.l-header-language-wrapper .l-dropdown-selected').focus();
        }
    });

    // Focus management for language dropdown - close when focus leaves
    $(document).on('focusout', '.l-header-language-wrapper', function(e) {
        var $this = $(this);
        
        setTimeout(function() {
            var $focused = $(document.activeElement);
            
            // Check if the newly focused element is outside the language wrapper
            if (!$this.is($focused) && !$this.has($focused).length) {
                if ($this.find('.l-dropdown-selected').hasClass('open')) {
                    closeLanguageDropdown();
                }
            }
        }, 0);
    });

    // Keyboard navigation support for profile menu
    $(document).on('keydown', '.l-header-profile-block', function(e) {
        // Close profile menu on Escape key
        if (e.key === 'Escape' || e.keyCode === 27) {
            closeProfileMenu();
            $('#l-header-profile').focus();
        }
    });

    // Focus management for profile menu - close when focus leaves
    $(document).on('focusout', '.l-header-profile-block', function(e) {
        var $this = $(this);
        
        setTimeout(function() {
            var $focused = $(document.activeElement);
            
            // Check if the newly focused element is outside the profile block
            if (!$this.is($focused) && !$this.has($focused).length) {
                if ($('.l-header-profile-user').hasClass('open')) {
                    closeProfileMenu();
                }
            }
        }, 0);
    });

    $(document).on('click','#l-header-profile', function(){
        $('.l-header-profile-user').toggleClass('open');
        updateProfileMenuTabIndex();
    });

    // Keyboard support for opening profile menu on Enter key
    $(document).on('keypress','#l-header-profile', function(e){
        if(e.keyCode == 13){ 
            $('.l-header-profile-user').toggleClass('open');
            updateProfileMenuTabIndex();
        }
    });
    $(window).on('popstate', function(event) {
        if($('#l-header-profile').hasClass('open')){
            $('#l-header-profile').toggleClass('open');
        }
    });
    $(document).on('click','.cart-info-close',function(e){
        let current_em = $(e.target);
        let attribute= $('#switch').attr('data-close')
       if(attribute=='switch-success'){
           localStorage.setItem('switchCompanySuccess',false)
       }
       if(attribute=='switch-error'){
           if(params.has('error')){
               localStorage.setItem('switchCompanyError',false)
           }else localStorage.setItem('switchCompanySuccess',false)
       }
        $(current_em).parents(".cart-info").fadeOut(300);
    });

})();
$(document).ready(function(){
    $('.l-header-menu-block #mobileNavigation .mtf-header-menu-link').attr('tabindex', '-1');
    $('.login-text').attr('tabindex', '-1');
    $('.login-text a').attr('tabindex', '-1');
    if(pathURL.includes('/a/content') || pathURL.includes('/pages/content')){
          $('[rel="alternate"]').each(function(){
            if($(this).attr('href').includes('monotypefonts')){
                const hrefLangAttr = $(this).attr('hreflang');
                const hrefAttr = $(this).attr('href');
                urltoUpdate = hrefAttr.split('?')[0];
                const url = new URL(urltoUpdate);
                const pagePath = url.pathname;
                if(hrefLangAttr === 'de') {
                    if(hrefAttr.includes('cms.monotypefonts')){
                        const searchTerm = hrefAttr.includes('/de') ? `${drupalApiImageBasicUrl}/de/` : `${drupalApiImageBasicUrl}/`;
                        const replaceTerm = monotypefonts_url_de + '/a/content/';
                        urltoUpdate = urltoUpdate.replace(searchTerm,replaceTerm);
                    }else {
                        urltoUpdate = monotypefonts_url_de + pagePath.replace('/a/content','/a/content');
                    }
                    $('#DE').attr("href", urltoUpdate);
                }
                else if(hrefLangAttr === 'fr') {
                    if(hrefAttr.includes('cms.monotypefonts')){
                        const searchTerm = hrefAttr.includes('/fr') ? `${drupalApiImageBasicUrl}/fr/` : `${drupalApiImageBasicUrl}/`;
                        const replaceTerm = monotypefonts_url_fr + '/a/content/';
                        urltoUpdate = urltoUpdate.replace(searchTerm,replaceTerm);
                    }else {
                        urltoUpdate = monotypefonts_url_fr + pagePath;
                    }
                    $('#FR').attr("href", urltoUpdate);
                }
                else if(hrefLangAttr === 'es') {
                    if(hrefAttr.includes('cms.monotypefonts')){
                        const searchTerm = hrefAttr.includes('/es') ? `${drupalApiImageBasicUrl}/es/` : `${drupalApiImageBasicUrl}/`;
                        const replaceTerm = monotypefonts_url_es + '/a/content/';
                        urltoUpdate = urltoUpdate.replace(searchTerm,replaceTerm);
                    }else {
                        urltoUpdate = monotypefonts_url_es + pagePath;
                    }
                    $('#ES').attr("href", urltoUpdate);
                }
                else if(hrefLangAttr === 'en') {
                    if(hrefAttr.includes('cms.monotypefonts')){
                        urltoUpdateUK = urltoUpdate.replace(drupalApiImageBasicUrl,monotypefonts_url_english_uk + '/a/content');
                        urltoUpdateUS = urltoUpdate.replace(drupalApiImageBasicUrl,monotypefonts_url_english_us + '/a/content');
                    
                    }else{
                        urltoUpdate = monotypefonts_url_english_us + pagePath;
                        urltoUpdateUS = urltoUpdate;
                        urltoUpdateUK = urltoUpdate.replace(monotypefonts_url_english_us,monotypefonts_url_english_uk);
                    }
                    $('#EN-UK').attr("href", urltoUpdateUK);
                    $('#EN-US').attr("href", urltoUpdateUS);
               }else if(hrefLangAttr === 'pt' || hrefLangAttr.toString() === 'pt-br') {
                    if(hrefAttr.includes('cms.monotypefonts')){
                        const searchTerm = hrefAttr.includes('/pt') ? `${drupalApiImageBasicUrl}/pt/` : `${drupalApiImageBasicUrl}/`;
                        let replaceTerm = ''
                        const pageName = pagePath.split('/').pop();
                        if(pageName == "resources" || pageName === "ressourcen"){
                            replaceTerm = monotypefonts_url_english_us + '/pt/a/content/';
                        }else{
                            replaceTerm = monotypefonts_url_english_us + '/pt/pages/content/';
                        }
                        urltoUpdate = urltoUpdate.replace(searchTerm,replaceTerm);
                        $('#PT').attr("href", urltoUpdate);
                    }
                    
                }
           }
        })
    }

   if (typeof window !== 'undefined' && window.location.href) {
        if (
            window.location.href.includes("plans-individual-and-small-teams-subscription") ||
            window.location.href.includes("plans-enterprise-subscription")
        ) {
            const tryForFreeLinks = Array.from(document.querySelectorAll('.mt-pas-plan-wrapper a')).filter(link =>
              link.href.includes('secure.monotype.com/authorize')
            ) || [];
            tryForFreeLinks.forEach(link => {
            if (link.href && link.href.includes("www.monotypefonts.com/pages/plans")) {
              link.href = link.href.replace(
                'www.monotypefonts.com/pages/plans',
                `${Shopify.locale === "pt-BR" ? `${window.location.hostname}/pt` : window.location.hostname}/pages/additional-information`
              );
            }
            });
        }
    }

    if(Shopify.country === "GB"){
        const createPitchLink = document.querySelector('a[href="https://www.monotypefonts.com/pages/content/plans-agency-subscription"]');
        const createDeployLink = document.querySelector('a[href="https://www.monotypefonts.com/pages/content/plans-individual-and-small-teams-subscription"]');
        const largeBrandsLink = document.querySelector('a[href="https://www.monotypefonts.com/pages/content/plans-enterprise-subscription"]');
        const cartLinks = document.querySelectorAll('a[data-analytics-linkname="Subscribe"]');
        const secondaryCartLinks = document.querySelectorAll(".mt-comparison-table--content--header--cta")
        if (createPitchLink) {
          createPitchLink.href = createPitchLink.href.replace('monotypefonts.com', 'monotypefonts.co.uk');
        }
        if (createDeployLink) {
          createDeployLink.href = createDeployLink.href.replace('monotypefonts.com', 'monotypefonts.co.uk');
        }
        if (largeBrandsLink) {
          largeBrandsLink.href = largeBrandsLink.href.replace('monotypefonts.com', 'monotypefonts.co.uk');
        }
        if (cartLinks) {
          cartLinks.forEach(link => {
            link.href = link.href.replace('monotypefonts.com', 'monotypefonts.co.uk');
          });
        }
        if (secondaryCartLinks) {
          secondaryCartLinks.forEach(link => {
            link.href = link.href.replace('monotypefonts.com', 'monotypefonts.co.uk');
          });
        }
    }
})


// cookie consent accessibility override
$(document).ready(function() {
    const observer = new MutationObserver(function(mutations) {
        for (let mutation of mutations) {
            if (mutation.type === 'childList') {
                const els = document.querySelectorAll('.ot-desc-cntr')
                if (els.length > 0) {
                    els.forEach(el => {
                        // remove tabindex attribute
                        el.removeAttribute('tabindex');
                    });
                    observer.disconnect(); // Stop observing once the elements are found
                }
            }
        }
    });
    // Start observing the document body for child list changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});


